// import * as Yup from "yup";

export const yupLocale = {
  mixed: {
    required: ({ path }: { path: string }) => `${path} is required`,
  },
};
